export default __webpack_public_path__ + "static/intensivzeit-29b6ab981b4461cd7ed227c746dfe3dd.png";